<template>
  <ChevronDownIcon class="h-4 w-4 align-middle" />
</template>

<script>
import { ChevronDownIcon } from '@heroicons/vue/outline'
export default {
  components: {
    ChevronDownIcon
  }
}
</script>

<style>

</style>
